import { combineReducers } from 'redux'

import reservations from './reservations'
import payments from './payments'

export default combineReducers({
  reservations,
  payments
})
